import * as React from 'react';
import { flow, isUndefined } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, ControlLabel, Form, FormGroup, Row} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { Field, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {
  IActivities,
  IChannel,
  ICustomer, IFrenchCommerceChamber,
  IIAS,
  IIOBSP,
  IProduct, IRealEstate, QuoteStatus,
} from '../../../../data/api/models';
import { IAuthState } from '../../../../services/auth/models';
import { II18nMessages } from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import {isRequired, isValidDate, siren, orias} from '../../../../util/validators';
import FieldFormControl from '../../../../components/FieldFormControl';
import SelectControl from '../../../../components/SelectControl';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import {getAvailableQuote, getReferralsAndDeclines, displayCurrency} from '../../../../util/helpers';
import Loading from '../../../../components/Loading';
import PostcodeControl from '../../../../components/PostcodeControl';

interface IInformationsFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  frenchCommerceChambers: IFrenchCommerceChamber[];
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };

  ias: IIAS;
  iobsp: IIOBSP;
  declaration: any;
  insured: ICustomer;
  realEstate: IRealEstate;
  paymentSchedule: string;
  status: string;
  activities: IActivities;
}

class InformationsForm extends React.Component<IInformationsFormProps, any> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    gross: 0,
  };

  public componentDidMount() {
    const { frenchCommerceChambers, actions, insured, dispatch, change, renewal, quote } = this.props;

    if (!frenchCommerceChambers.length) {
      actions.quote.loadFrenchCommerceChambers();
    }

    if (!isUndefined(insured) && insured.firstName === 'Test') {
      dispatch(change('insured.firstName', ''));
    }

    if (!isUndefined(insured) && insured.lastName === 'Test') {
      dispatch(change('insured.lastName', ''));
    }

    if (this.isRealEstate()) {
      dispatch(change('insured.metadata.status', 'individual'));
    }

    if (renewal && insured && insured.metadata.orias && insured.metadata.orias.substr(0, 2) === '00') {
      dispatch(change('renewalSirenChange', true));
    }

    if (quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      actions.quote.saveQuote(true);
    }
  }

  public componentWillReceiveProps(nextProps) {
    const {
      quote,
      actions,
      paymentSchedule,
      dispatch,
      change,
    } = this.props;

    const availableQuote = getAvailableQuote(quote);
    if (availableQuote.length) {
      if (isUndefined(quote.annualGrossPremium) || quote.annualGrossPremium !== availableQuote[0].gross) {
        actions.quote.setAnnualGrossPremium(availableQuote[0].gross);
      }
    }

    if (!quote.isCalculating) {
      const referralsAndDeclines = getReferralsAndDeclines(quote);
      if (JSON.stringify(this.state.declines) !== JSON.stringify(referralsAndDeclines.declines)) {
        this.setState({declines: referralsAndDeclines.declines});
      }
      if (JSON.stringify(this.state.referrals) !== JSON.stringify(referralsAndDeclines.referrals)) {
        this.setState({referrals: referralsAndDeclines.referrals});
        if (!referralsAndDeclines.declines.length && referralsAndDeclines.referrals.length) {
          actions.quote.referralQuote(quote.application.id, referralsAndDeclines.referrals);
        }
      }
      if (JSON.stringify(this.state.errors) !== JSON.stringify(referralsAndDeclines.errors)) {
        this.setState({errors: referralsAndDeclines.errors});
      }
    }

    if (paymentSchedule !== nextProps.paymentSchedule) {
      dispatch(change('paymentSchedule', nextProps.paymentSchedule));
    }
  }

  private checkRenewalSirenChange = () => {
    const { renewal, dispatch, change } = this.props;
    if (renewal) {
      dispatch(change('renewalSirenChange', true));
    }
  }

  private handleSelectAddress = (address: string) => {
    const { change } = this.props;
    const base = 'insured.address';

    change(`${base}.town`, address);
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    if (! declines.length && this.props.quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/declarations'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }
  private nameField(title: string, key: string, required: boolean) {
    return (
      <FormGroup controlId={'customer'}>
        <Col componentClass={ControlLabel} sm={6}>
          {title}
        </Col>
        <Col sm={6}>
          <div className="full-name-fields">
            <Row>
              {/*<Col sm={3}>*/}
                {/*<TitleField*/}
                  {/*type={'adult'}*/}
                  {/*name={key + '.title'}*/}
                  {/*validate={[ isRequired ]}*/}
                {/*/>*/}
              {/*</Col>*/}
              <Col sm={6}>
                <Field
                  type="text"
                  placeholder="Prénom"
                  name={key + '.firstName'}
                  component={FieldFormControl}
                  validate={required ? [ isRequired ] : []}
                />
              </Col>
              <Col sm={6}>
                <Field
                  type="text"
                  placeholder="Nom"
                  name={key + '.lastName'}
                  component={FieldFormControl}
                  validate={required ? [ isRequired ] : []}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </FormGroup>
    );
  }

  private individual() {
    const { insured, declaration } = this.props;
    if (insured.metadata.status !== 'individual') {
      return null;
    }

    return (
      <div>

        {this.nameField('Nom', 'insured', true)}

        <FormGroup controlId={'address'}>
          <Col componentClass={ControlLabel} sm={6}>
            Votre adresse
          </Col>
          <Col sm={6}>
            <Field
              type="text"
              className="address-field"
              name={'insured.address.line1'}
              component={FieldFormControl}
              validate={[ isRequired ]}
              placeholder={'Adresse'}
            />
            <Field
              type="text"
              className="address-field"
              name={'insured.address.line2'}
              component={FieldFormControl}
              placeholder={'Adresse'}
            />
            <Field
              type="text"
              className="address-field"
              name={'insured.address.line3'}
              component={FieldFormControl}
              placeholder={'Complément d’adresse'}
            />
            <Field
              name={'insured.address.postcode'}
              type="text"
              className="address-field"
              component={PostcodeControl}
              onSelectAddress={this.handleSelectAddress}
              placeholder={'Code postal'}
              validate={[ isRequired ]}
            />
            <Field
              type="text"
              className="address-field"
              name={'insured.address.town'}
              component={FieldFormControl}
              validate={[ isRequired ]}
              placeholder={'Ville'}
            />
          </Col>
        </FormGroup>

        {! this.isRealEstate() && (
          <FormGroup controlId={'orias'}>
            <Col componentClass={ControlLabel} sm={6}>
              {this.props.renderDefinition('insured.metadata.orias')}
              Numéro ORIAS
            </Col>
            <Col sm={6}>
              <div className="full-name-fields">
                <Row>
                  <Col sm={12}>
                    <Field
                      type="text"
                      placeholder="Numéro ORIAS"
                      name={'insured.metadata.orias'}
                      component={FieldFormControl}
                      validate={declaration[3] !== 'true' ? [ isRequired, orias ] : [orias]}
                      onChange={this.checkRenewalSirenChange}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </FormGroup>
        )}

        <FormGroup controlId={'siren'}>
          <Col componentClass={ControlLabel} sm={6}>
            {this.props.renderDefinition('insured.metadata.siren')}
            Numéro de siren
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Numéro de siren"
                    name={'insured.metadata.siren'}
                    component={FieldFormControl}
                    validate={[ isRequired, siren ]}
                    onChange={this.checkRenewalSirenChange}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

      </div>
    );
  }

  private company() {
    const { insured, declaration } = this.props;
    if (insured.metadata.status !== 'company') {
      return null;
    }

    return (
      <div>
        <FormGroup controlId={'siren'}>
          <Col componentClass={ControlLabel} sm={6}>
            Dénomination sociale
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Dénomination sociale"
                    name={'insured.companyName'}
                    component={FieldFormControl}
                    validate={[ isRequired ]}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

        {this.nameField('Nom du dirigeant', 'insured', true)}

        <FormGroup controlId={'address'}>
          <Col componentClass={ControlLabel} sm={6}>
            Votre adresse
          </Col>
          <Col sm={6}>
            <Field
              type="text"
              className="address-field"
              name={'insured.address.line1'}
              component={FieldFormControl}
              validate={[ isRequired ]}
              placeholder={'Adresse'}
            />
            <Field
              type="text"
              className="address-field"
              name={'insured.address.line2'}
              component={FieldFormControl}
              placeholder={'Adresse'}
            />
            <Field
              type="text"
              className="address-field"
              name={'insured.address.line3'}
              component={FieldFormControl}
              placeholder={'Complément d’adresse'}
            />
            <Field
              name={'insured.address.postcode'}
              type="text"
              className="address-field"
              component={PostcodeControl}
              onSelectAddress={this.handleSelectAddress}
              placeholder={'Code postal'}
              validate={[ isRequired ]}
            />
            <Field
              type="text"
              className="address-field"
              name={'insured.address.town'}
              component={FieldFormControl}
              validate={[ isRequired ]}
              placeholder={'Ville'}
            />
          </Col>
        </FormGroup>

        <FormGroup controlId={'orias'}>
          <Col componentClass={ControlLabel} sm={6}>
            {this.props.renderDefinition('insured.metadata.orias')}
            Numéro ORIAS
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Numéro ORIAS"
                    name={'insured.metadata.orias'}
                    component={FieldFormControl}
                    validate={declaration[3] !== 'true' ? [ isRequired, orias ] : [ orias ]}
                    onChange={this.checkRenewalSirenChange}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

        <FormGroup controlId={'siren'}>
          <Col componentClass={ControlLabel} sm={6}>
            {this.props.renderDefinition('insured.metadata.siren')}
            Numéro de siren
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Numéro de siren"
                    name={'insured.metadata.siren'}
                    component={FieldFormControl}
                    validate={[ isRequired, siren ]}
                    onChange={this.checkRenewalSirenChange}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

      </div>
    );
  }

  private insuredPersons(key: string, total: number) {
    const insuredPersons = [];

    for (let i = 0; i < total; i++) {
      insuredPersons.push(
        <FormGroup key={i + 1} controlId={key + '[' + i + '].name'}>
          <Col componentClass={ControlLabel} sm={6}>
            Mandataire {(i + 1)} nom- prénom ou dénomination sociale
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder={'Mandataire ' + (i + 1) + ' nom- prénom ou dénomination sociale'}
                    name={key + '[' + i + '].name'}
                    component={FieldFormControl}
                    validate={[ isRequired ]}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>,
      );
      insuredPersons.push(
        <FormGroup key={i + 2} controlId={key + '[' + i + '].orias'}>
          <Col componentClass={ControlLabel} sm={6}>
            Mandataire {(i + 1)} N° ORIAS
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder={'Mandataire ' + (i + 1) + ' N° ORIAS'}
                    name={key + '[' + i + '].orias'}
                    component={FieldFormControl}
                    validate={[ isRequired, orias ]}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>,
      );
      insuredPersons.push(
        <FormGroup key={i + 3} controlId={key + '[' + i + '].siren'}>
          <Col componentClass={ControlLabel} sm={6}>
            Mandataire {(i + 1)} Numéro de SIREN
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="number"
                    placeholder={'Mandataire ' + (i + 1) + ' Numéro de SIREN'}
                    name={key + '[' + i + '].siren'}
                    component={FieldFormControl}
                    validate={[ isRequired, siren ]}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>,
      );
    }

    return insuredPersons;
  }

  private ias() {
    const { ias } = this.props;
    if (ias.declaration[6] !== 'true') {
      return null;
    }

    const total = parseInt(ias.declaration[7], 10);
    if (total <= 0) {
      return null;
    }

    return (
      <div>
        <div>
          <h5>Au titre de l'activité IAS</h5>
        </div>
        {this.insuredPersons('ias.insuredPersons', total)}
        <hr/>
      </div>
    );
  }

  private iobsp() {
    const { iobsp } = this.props;
    if (iobsp.declaration[1] !== 'true') {
      return null;
    }

    const total = parseInt(iobsp.declaration[2], 10);
    if (total <= 0) {
      return null;
    }

    return (
      <div>
        <div>
          <h5>Au titre de l'activité IOBSP</h5>
        </div>

        {this.insuredPersons('iobsp.insuredPersons', total)}

        <hr/>
      </div>
    );
  }

  private realEstate() {
    const { realEstate } = this.props;
    if (! realEstate.included) {
      return null;
    }

    const { frenchCommerceChambers } = this.props;
    const chambers = [];
    frenchCommerceChambers.map((chamber) => {
      chambers.push({
        label: chamber.name,
        value: chamber.id,
      });
    });

    return (
      <div>

        <FormGroup controlId={'realEstate.principal'}>
          <Col componentClass={ControlLabel} sm={6}>
            Nom de la société mandante
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Nom de la société mandante"
                    name={'realEstate.principal'}
                    component={FieldFormControl}
                    validate={[ isRequired ]}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

        {this.nameField('Nom et prénom du représentant légal du mandant', 'realEstate.representative', true)}

        <FormGroup controlId={'realEstate.representative.status'}>
          <Col componentClass={ControlLabel} sm={6}>
            Fonction du représentant légal
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Veuillez sélectionner"
                    name={'realEstate.representative.status'}
                    component={SelectControl}
                    validate={[ isRequired ]}
                    options={[
                      { label: 'Gérant', value: 'Gérant' },
                      { label: 'Co-Gérants', value: 'Co-Gérants' },
                      { label: 'Président', value: 'Président' },
                      { label: 'Directeur Géneral', value: 'Directeur Géneral' },
                    ]}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

        {realEstate.representative.status === 'Co-Gérants' && (
          <div>
            {this.nameField('Nom et prénom du deuxième co-gérant', 'realEstate.comanager', true)}
            {this.nameField('Nom et prénom du troisième co-gérant', 'realEstate.comanager1', false)}
          </div>
        )}

        <FormGroup controlId={'realEstate.representative.cardNumber'}>
          <Col componentClass={ControlLabel} sm={6}>
            Numéro de la carte professionnelle du mandant
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Numéro de la carte professionnelle du mandant"
                    name={'realEstate.representative.cardNumber'}
                    component={FieldFormControl}
                    validate={[ isRequired ]}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

        <FormGroup controlId={'realEstate.representative.chamber'}>
          <Col componentClass={ControlLabel} sm={6}>
            Nom de la Chambre de commerce qui a délivré la carte professionnelle du mandant
          </Col>
          <Col sm={6}>
            <div className="full-name-fields">
              <Row>
                <Col sm={12}>
                  <Field
                    type="text"
                    placeholder="Veuillez sélectionner"
                    name={'realEstate.representative.chamber'}
                    component={SelectControl}
                    validate={[ isRequired ]}
                    options={chambers}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </FormGroup>

        <FormGroup controlId="realEstate.representative.issueDate">
          <Col componentClass={ControlLabel} sm={6}>
            Date de délivrance de cette carte
          </Col>
          <Col sm={6}>
            <div className="field">
              <Field
                name="realEstate.representative.issueDate"
                type="masked-date"
                placeholder="dd/mm/yyyy"
                component={FieldFormControl}
                validate={[ isRequired, isValidDate ]}
                readOnly={false}
              />
            </div>
          </Col>
        </FormGroup>
      </div>
    );
  }

  private isRealEstate() {
    return ! isUndefined(this.props.activities) &&
      ! isUndefined(this.props.activities.realEstate) &&
      this.props.activities.realEstate.percent === '100';
  }

  private customerType() {
    return (
      <FormGroup controlId={'insured.metadata.status'}>
        <div className="declaration-container">
          <div className="declaration-section no-bg">
            <Col componentClass={ControlLabel} sm={6}>
              Vous êtes une
            </Col>

            <Col sm={3}>
              <Field
                name={'insured.metadata.status'}
                type="radio"
                format={null}
                value={'individual'}
                className="answer"
                component={FieldFormControl}
                validate={[ isRequired ]}
              >
                <div className="declaration-btn">
                  Personne physique
                </div>
              </Field>
            </Col>
            <Col sm={3}>
              <Field
                name={'insured.metadata.status'}
                type="radio"
                format={null}
                value={'company'}
                className="answer"
                component={FieldFormControl}
                validate={[ isRequired ]}
                disabled={this.isRealEstate()}
              >
                <div className={'declaration-btn'}>
                  Personne morale
                </div>
              </Field>
            </Col>
          </div>
        </div>
      </FormGroup>
    );
  }

  private annualPremiumBar() {
    const { quote } = this.props;

    if (quote.annualGrossPremium <= 0) {
      return null;
    }
    return (
      <div className="alert alert-colored margin-top">
        <Row>
          <Col md={10}>
            <span className="premium text">
              Votre prime TTC sur la base d'un paiement annuel:
            </span>
          </Col>
          <Col md={2}>
            <span className="premium float-right">
              {displayCurrency(quote.annualGrossPremium)} €
            </span>
          </Col>
        </Row>
      </div>
    );
  }

  private notReady() {
    const { ias, iobsp, realEstate } = this.props;
    return isUndefined(ias) || isUndefined(iobsp) || isUndefined(realEstate) || this.props.quote.isCalculating;
  }

  public render() {
    const { handleSubmit, quote } = this.props;
    if (this.notReady()) {
      return (
        <div className={'loading-center'}>
          <Loading size={100}/>
        </div>
      );
    }

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declinesOrReferrals) {
      return declinesOrReferrals;
    }

    const ias = this.ias();
    const iobsp = this.iobsp();
    const realEstate = this.realEstate();

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          {this.annualPremiumBar()}

          <div>
            <h3>Vos coordonnées</h3>
            <strong>Si vous souhaitez obtenir une proposition d’assurance sur cette base tarifaire,
              merci de compléter les informations suivantes :</strong>
          </div>

          {this.customerType()}

          <hr/>

          {this.individual()}
          {this.company()}

          {(ias || iobsp) && (
            <div>
              <h4>Nom de vos mandataires personnes physiques déclarés
                ci-avant que vous souhaitez assurer dans votre contrat:</h4>
              <hr/>

            </div>
          )}

          {ias}
          {iobsp}
          {realEstate}

          <NavigationBar
            hasBackButton={quote.application.status !== QuoteStatus.REFERRAL_APPROVED}
            backTo={'/declarations'}
            {...this.props}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const declaration = selector(state, 'declaration');
      const ias = selector(state, 'ias');
      const iobsp = selector(state, 'iobsp');
      const insured = selector(state, 'insured');
      const realEstate = selector(state, 'realEstate');
      const paymentSchedule = selector(state, 'paymentSchedule');
      const status = selector(state, 'status');
      const activities = selector(state, 'activities');

      return {
        startDate,
        quotationTypes,
        auth: state.auth,
        declaration,
        ias,
        iobsp,
        insured,
        realEstate,
        paymentSchedule,
        frenchCommerceChambers: state.quote.frenchCommerceChambers,
        status,
        activities,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(InformationsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Informations/index.tsx